import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

const ERROR_MSG_RECIPIENTS = 'Debe seleccionar un grupo de invitados (y sus clubes), un grupo predeterminado ' +
    'o emails individuales.'

export const recipientsMixin = {
  mixins: [validationMixin],

  validations: {
    message: { required },
    title: { required }
  },

  data: () => ({
    customErrorMessage: '',
    customErrorPresent: false,
    loadingCriterion: true,
    loadingClubs: false,
    loadingGrupos: true,
    message: '',
    personas: [],
    personasNames: [],
    clubes: [],
    clubesNames: [],
    grupos: [],
    gruposNames: [],
    title: '',
    saving: false,
    errorRecipients: ERROR_MSG_RECIPIENTS,
    loadingCategorias: true,
    categorias: [],
    categoriasNames: [],
    fetchClubsOnCategorySelection: false
  }),

  computed: {
    messageErrors () {
      return this.getRequiredErrors('message', 'La descripción es requerida.')
    },
    titleErrors () {
      return this.getRequiredErrors('title', 'El título es requerido.')
    },
    dateErrors () {
      return this.getRequiredErrors('date')
    },
    timeErrors () {
      return this.getRequiredErrors('time')
    }
  },

  watch: {
    categorias (newCategorias, oldCategorias) {
      if (this.fetchClubsOnCategorySelection) {
        this.fetchClubes(newCategorias)
      }
    }
  },

  methods: {
    fetchClubes (categoriasSeleccionadas) {
      this.loadingClubs = true
      let url = 'clubes'

      if (categoriasSeleccionadas && categoriasSeleccionadas.length > 0) {
        const categoriaIds = categoriasSeleccionadas.join(',')
        url = `clubes?categories=${categoriaIds}`
      } else if (this.fetchClubsOnCategorySelection) {
        this.clubesNames = []
        this.loadingClubs = false
        return
      }

      this.axios
        .get(url)
        .then(response => {
          this.clubesNames = response.data
          this.loadingClubs = false
        })
        .catch(error => {
          this.loadingClubs = false
          this.$store.commit('setErrorMsg', error)
        })
    },
    areCustomValidationsValid () {
      let userDefinedPersonas = this.personas && this.personas.length > 0 && this.clubes && this.clubes.length > 0
      if (!userDefinedPersonas) {
        if ((this.personas.length > 0 && this.clubes.length <= 0) ||
            (this.personas.length <= 0 && this.clubes.length > 0)) {
          return false
        }
      }
      let userDefinedEmails = this.$refs.emails.getEmails().length > 0
      let userDefinedGrupos = this.grupos && this.grupos.length > 0
      return userDefinedPersonas || userDefinedEmails || userDefinedGrupos
    },
    handleCustomErrors () {
      this.customErrorPresent = true
      this.customErrorMessage = this.errorRecipients
    },
    cleanForm () {
      this.customErrorPresent = false
      this.customErrorMessage = ''
    },
    getRequiredErrors (property, message = 'Este campo es requerido.') {
      const errors = []
      if (!this.$v[property].$dirty) return errors
      !this.$v[property].required && errors.push(message)
      return errors
    },
    fetchData () {
      if (this.editingEvent) {
        this.fetchEditingEventData()
      } else {
        this.axios
          .get('person_criterion_definitions')
          .then(response => {
            this.personasNames = this.disambiguatePersonasNames(response.data)
            this.loadingCriterion = false
          })
          .catch(error => { this.$store.commit('setErrorMsg', error) })
        this.axios
          .get('informe-auditoria/categorias')
          .then(response => {
            this.categoriasNames = response.data
            this.loadingCategorias = false
          })
          .catch(error => { this.$store.commit('setErrorMsg', error) })
        this.axios
          .get('grupos_de_personas')
          .then(response => {
            this.gruposNames = response.data
            this.loadingGrupos = false
          })
          .catch(error => { this.$store.commit('setErrorMsg', error) })
      }
    },
    goBack () {
      this.goBackConfirmed = true
      this.$router.go(-1)
    },
    submit () {
      this.cleanForm()
      this.$v.$touch()
      this.$refs.emails.validateEmails()
      if (!this.areCustomValidationsValid()) {
        this.handleCustomErrors()
        return
      }
      if (!this.$v.$invalid && this.$refs.emails.isValid()) {
        const payload = this.getPayload()
        this.saving = true
        this.axios
          .post(this.apiPath, payload)
          .then(() => {
            this.saving = false
            this.goBack()
          })
          .catch(error => {
            this.saving = false
            this.$store.commit('setErrorMsg', error)
          })
      }
    },
    groupBy (OurArray, property) {
      return OurArray.reduce((accumulator, object) => {
        const key = object[property]
        let currentGroupOrNull = accumulator[key]
        if (!currentGroupOrNull) {
          accumulator[key] = [object]
        } else {
          accumulator[key].push(object)
        }
        return accumulator
      }, {})
    },
    disambiguatePersonasNames (data) {
      let result = []
      let personasGroupByName = this.groupBy(data, 'nombre')
      for (let groupName of Object.keys(personasGroupByName)) {
        if (personasGroupByName[groupName].length === 1) {
          result.push(personasGroupByName[groupName][0])
          continue
        }

        for (let duplicatedPersonaName of personasGroupByName[groupName]) {
          duplicatedPersonaName.nombre = `${duplicatedPersonaName.nombre} (${duplicatedPersonaName.area})`
          result.push(duplicatedPersonaName)
        }
      }

      return result
    }
  },

  created () {
    this.fetchData()
    if (!this.fetchClubsOnCategorySelection) {
      this.fetchClubes()
    }
  }
}
